// extracted by mini-css-extract-plugin
export default {"blueColor":"#4a90e2","onboardingHeader":"Y1bu1NUG3ZnHJx1uwnli7"};